import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Box, Text, Timer } from '@bonanza-social/moonlight';
import { selectPrizeWallOpenDate } from '../../state/prizeWall/prizeWall.slice';
import { PrizeWallOpenInfoProps } from './PrizeWallOpenInfo.types';

function PrizeWallOpenInfo(props: PrizeWallOpenInfoProps) {
  const openDate = useSelector(selectPrizeWallOpenDate);

  return (
    <Box
      flexDirection="row"
      padding="space-200"
      borderRadius="radius-full"
      borderColor="borderSecondary"
      borderWidth="border-width-025"
      backgroundColor="primaryBackgroundHover"
      centerContent
      {...props}
    >
      <Text
        variant="caption"
        locNS="prizeWall"
        locKey="prizeWallOpenInfo"
        color="darkSurfacePrimary"
        textAlign="center"
      />
      {openDate && (
        <Timer variant="caption" color="darkSurfacePrimary" time={openDate} />
      )}
    </Box>
  );
}

export default memo(PrizeWallOpenInfo);
